import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { postNotification } from '../api/api';
import { showToast } from '../components/utils/toast';
import { useTranslation } from 'react-i18next';

const markAllNotificationsAsRead = async (): Promise<void> => {
  return postNotification(`${API_URLS_ENTITY.NOTIFICATIONS.NOTIFICATION_FEED}/mark-all-as-read`);
};

export const useMarkAllNotificationsAsRead = (): UseMutationResult<
  void,
  AxiosError<{ message?: string; type?: string }>,
  void
> => {
  const { setIsLoading } = useLoading();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: () => markAllNotificationsAsRead(),
    onMutate: () => {
      setIsLoading(true);
    },
    onSuccess: () => {
      showToast('success', t('common:markAllNotificationsAsReadInfo'));
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
